import {
    CircularProgress,
    createStyles,
    Fab,
    WithStyles,
    withStyles
} from "@material-ui/core";
import { FabProps } from "@material-ui/core/Fab";
import React from "react";

type LoaderFabProps = FabProps &
    WithStyles<typeof styles> & {
        disabled: boolean;
        text?: string;
    };

const styles = () =>
    createStyles({
        circularLoader: {
            left: "50%",
            marginLeft: -12,
            marginTop: -12,
            position: "absolute",
            top: "50%"
        },
        wrapper: {
            display: "inline-block",
            position: "relative",
            width: "fit-content"
        }
    });

class LoaderFab extends React.PureComponent<LoaderFabProps, {}> {
    public render() {
        const classes = this.props.classes;
        const loaderColor =
            this.props.color === "primary" ? "secondary" : "primary";

        const fabProps = { ...this.props } as Partial<LoaderFabProps>;
        delete fabProps.classes;

        return (
            <div className={classes.wrapper}>
                <Fab {...fabProps}>
                    {this.props.text || this.props.children}
                </Fab>
                {this.props.disabled && (
                    <CircularProgress
                        size={24}
                        color={loaderColor}
                        className={classes.circularLoader}
                    />
                )}
            </div>
        );
    }
}

export default withStyles(styles)(LoaderFab);
